// extracted by mini-css-extract-plugin
module.exports = {"home":"Divisions_home__38Zd4","textFields":"Divisions_textFields__mI7EQ","actionButton":"Divisions_actionButton__ydbjQ","error":"Divisions_error__3RKg3"};